import React, { useMemo } from "react";
import Popup from "reactjs-popup";

import CloseIcon from "@mui/icons-material/Close";
import { Chip } from "@mui/material";
import { capitalize } from "lodash";
import { ReportFilters } from "store/types";

import "./FiltersChip.styles.scss";

const toCapitalizeList: Array<keyof ReportFilters> = ["round", "deal_name"];

type Option = string | number | boolean | object;
interface Props<Field, Opt> {
  field: Field;
  renderField?: (field: Field) => string;
  options: Array<Opt> | null;
  renderOption?: (option: Opt) => string;
  onRemove: (field: Field) => void;
  removeFieldOption: ({ field, option }: { field: Field; option: Opt }) => void;
  disabled?: boolean;
}

export function FiltersChip<Field extends object | string, Opt extends Option>({
  field,
  options,
  onRemove,
  removeFieldOption,
  renderField,
  renderOption,
  disabled
}: Props<Field, Opt>) {
  const label: string = useMemo(() => {
    if (typeof field === "object") {
      return renderField?.(field) || field.toString();
    } else {
      return field as string;
    }
  }, [field, renderField]);

  if (!options?.length) {
    return null;
  }

  const showLabel = (label: string) => {
    if (toCapitalizeList?.includes(label)) {
      return capitalize(label).replace(/_/g, " ");
    }
    if (label === "File Type") {
      return "Type";
    }
    return label;
  };

  const simpleOptionLabel = (option: string) => {
    if (typeof field === "object" && "key" in field && field.key === "file_types") {
      return option.toUpperCase();
    }
    return option;
  };

    return (
    <div className="filters-chip">
      <Popup
        offsetY={20}
        disabled={disabled}
        trigger={
          <Chip
            sx={{ height: "26px", fontSize: "15px", color: "#0a3142" }}
            label={`${showLabel(label)} (${options?.length})`}
            onDelete={() => {
              if (disabled) return;
              onRemove(field);
            }}
          />
        }
      >
        <div className="filters-chip__popup">
          <div className="filters-chip__popup-title">{showLabel(label)}</div>
          <ul className="filters-chip__list">
            {options?.map((option) => (
              <li className="filters-chip__item" key={option.toString()}>
                {typeof option === "object"
                  ? renderOption?.(option) || option.toString()
                  : simpleOptionLabel(option as string)}
                <CloseIcon
                  className="icon"
                  onClick={() => {
                    if (disabled) return;
                    removeFieldOption({ field, option });
                  }}
                />
              </li>
            ))}
          </ul>
        </div>
      </Popup>

      {/* <CloseIcon className="icon" onClick={() => onRemove(title)} /> */}
    </div>
  );
}

// export const FiltersChip: React.FC<Props> = ({
//   field,
//   options,
//   onRemove,
//   removeFieldOption,
//   renderField,
//   renderOption
// }) => {
//   const label: string = useMemo(() => {
//     if (typeof field === "object") {
//       return renderField?.(field) || field.toString();
//     } else {
//       return field;
//     }
//   }, [field, renderField]);

//   return (
//     <div className="filters-chip">
//       <Popup
//         offsetY={20}
//         trigger={<Chip size="small" label={`${label} ${options?.length}`} onDelete={() => onRemove(field)} />}
//       >
//         <div className="filters-chip__popup">
//           <div className="filters-chip__popup-title">{label}</div>
//           <ul className="filters-chip__list">
//             {options?.map((option) => (
//               <li className="filters-chip__item" key={option.toString()}>
//                 {typeof option === "object" ? renderOption?.(option) || option.toString() : option}
//                 <CloseIcon className="icon" onClick={() => removeFieldOption({ field, option })} />
//               </li>
//             ))}
//           </ul>
//         </div>
//       </Popup>

//       {/* <CloseIcon className="icon" onClick={() => onRemove(title)} /> */}
//     </div>
//   );
// };
